import { render, staticRenderFns } from "./rules-inner.vue?vue&type=template&id=6bc4fd0c"
import script from "./rules-inner.vue?vue&type=script&lang=js"
export * from "./rules-inner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/rules/rules-inner.vue
// module id = 9aED
// module chunks = 0